import React, {FC, memo, useEffect} from 'react';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';

import {sendCommonAnalytics, getAnalyticsLocationInfo} from 'libs/analytics/setDimension';

export type PropType = {
    headerComponent?: React.ReactNode;
    pageType:
        | 'cart'
        | 'default'
        | 'postPurchaseInsurance'
        | 'orderTracking'
        | 'uploadPrescription'
        | 'quizResults'
        | 'quiz'
        | 'blog'
        | 'home';
    sendAnalytics?: () => void;
};

export const ANALYTICS_PAGES: {
    [key in PropType['pageType']]: {page_type_param2: string | null; event: string | null};
} = {
    postPurchaseInsurance: {
        page_type_param2: 'OTHER',
        event: '@REACTPV_otherPages',
    },
    cart: {
        page_type_param2: 'CART',
        event: '@REACTPV_Cart',
    },
    orderTracking: {
        page_type_param2: 'OrderTracking',
        event: '@REACTPV_otherPages',
    },
    uploadPrescription: {
        page_type_param2: 'OTHER',
        event: '@REACTPV_otherPages',
    },
    quiz: {
        page_type_param2: 'QUIZ',
        event: '@REACTPV_otherPages',
    },
    quizResults: {
        page_type_param2: 'OTHER',
        event: '@REACTPV_otherPages',
    },
    blog: {
        page_type_param2: 'BLOG',
        event: '@REACTPV_Blog',
    },
    home: {
        page_type_param2: 'HOMEPAGE',
        event: '@REACTPV_Homepage',
    },
    default: {
        page_type_param2: '',
        event: '',
    },
};

export const PageWrapper: FC<PropType> = memo(
    ({children, headerComponent, pageType, sendAnalytics}) => {
        useEffect(() => {
            const {page_type_param2: pageTypeParam, event} = ANALYTICS_PAGES[pageType];

            if (pageTypeParam) pushDataLayer({page_type_param2: pageTypeParam});
            sendCommonAnalytics();
            if (event) pushDataLayer({event, ...getAnalyticsLocationInfo()});
            if (sendAnalytics) sendAnalytics();
        }, [pageType, sendAnalytics]);
        return (
            <>
                {headerComponent || null}
                {children}
            </>
        );
    },
);
